"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/echartsNew/index"));
var _newToExcel = _interopRequireDefault(require("@/utils/newToExcel.js"));
var _statistic = require("@/api/statistic");
var _permission = require("@/utils/permission");
var _vueCountTo = _interopRequireDefault(require("vue-count-to"));
var jumpApi = _interopRequireWildcard(require("@/api/jumpApi"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  components: {
    echartsNew: _index.default,
    countTo: _vueCountTo.default
  },
  data: function data() {
    return {
      spinShow: false,
      grid: {
        xl: 8,
        lg: 8,
        md: 8,
        sm: 24,
        xs: 24
      },
      options: this.$timeOptions,
      name: '近30天',
      timeVal: [],
      fromList: this.$constants.timeList,
      dateLimit: '',
      dateLimitPram: {},
      list: [],
      optionData: {},
      optionDataTwo: {},
      style: {
        height: '700px'
      },
      pickerOptions: this.$timeOptions,
      //快捷时间选项

      selectedList: [],
      selecterVales: null,
      dataRight: [{
        name: '新用户量',
        value: ''
      }, {
        name: '用户总量',
        value: ''
      }, {
        name: '活跃量',
        value: ''
      }, {
        name: '流失量',
        value: ''
      }, {
        name: '访问量',
        value: ''
      }, {
        name: '人均停留时长',
        value: ''
      }, {
        name: '用户已下单量',
        value: ''
      }, {
        name: '人均订单金额',
        value: ''
      }],
      text: [{
        name: '昨天',
        dateLimit: 'yesterday'
      }, {
        name: '最近7天',
        dateLimit: 'lately7'
      }, {
        name: '最近30天',
        dateLimit: 'lately30'
      }],
      //用户点击分析
      jumpType: [],
      urlId: '',
      urlName: '',
      urlType: '',
      skinId: '',
      skinName: '',
      orderByType: '',
      userClickPage: 1,
      userClickLimit: 10,
      userClickDataTotal: 0,
      userClickDataList: [],
      urlTypeOptions: jumpApi.getJumpOptions(),
      userClickLoading: false,
      //用户搜索分析
      searchMsgPage: 1,
      searchMsgLimit: 10,
      searchMsgDataTotal: 0,
      searchMsgDataList: [],
      orderByType2: '',
      searchMsgLoading: false
    };
  },
  created: function created() {
    this.timeVal = [];
  },
  mounted: function mounted() {
    this.handleAppList();
    this.dateLimit = 'lately7';
    this.dateLimitPram = 'lately7';
    this.jumpType = jumpApi.getJumpOptions();
    this.getUserClickData('search');
    this.getUserSearchData();
  },
  methods: {
    arraySpanMethod: function arraySpanMethod(_ref) {
      var row = _ref.row,
        column = _ref.column,
        rowIndex = _ref.rowIndex,
        columnIndex = _ref.columnIndex;
      console.log(row, column, rowIndex, columnIndex);
      // if (columnIndex === 0) {
      //   if (rowIndex % 2 === 0) {
      //     return {
      //       rowspan: 2,
      //       colspan: 1
      //     }
      //   } else {
      //     return {
      //       rowspan: 0,
      //       colspan: 0
      //     }
      //   }
      // }
    },
    // 链接类型
    transportShowType: function transportShowType(type) {
      var info = jumpApi.transportJumpType(type);
      return info === null || info === void 0 ? void 0 : info.title;
    },
    // 处理排序
    handleSort: function handleSort(field) {
      var ascValue = '';
      var descValue = '';

      // 根据字段设置对应的升序和降序值
      switch (field) {
        case 'totalDuration':
          ascValue = '1';
          descValue = '2';
          break;
        case 'visitTimes':
          ascValue = '3';
          descValue = '4';
          break;
        case 'visitUsers':
          ascValue = '5';
          descValue = '6';
          break;
      }

      // 判断当前是否为此字段的排序状态
      var isCurrentFieldSorting = this.orderByType === ascValue || this.orderByType === descValue;
      if (!isCurrentFieldSorting) {
        // 如果不是当前字段排序，设置为升序
        this.orderByType = ascValue;
      } else if (this.orderByType === ascValue) {
        // 如果是升序，切换为降序
        this.orderByType = descValue;
      } else {
        // 如果是降序，切换为升序
        this.orderByType = ascValue;
      }

      // 重新获取数据
      this.userClickPage = 1; // 重置到第一页
      this.getUserClickData('search');
    },
    //获取用户点击分析数据
    getUserClickData: function () {
      var _getUserClickData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(type) {
        var reqData, res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              // console.log(this.userClickPage, this.userClickLimit)
              if (type == 'reset') {
                this.urlId = '';
                this.urlName = '';
                this.urlType = '';
                this.skinId = '';
                this.skinName = '';
                this.userClickPage = 1;
                this.userClickLimit = 10;
                this.orderByType = '';
              }
              if (type == 'searchClick') {
                this.userClickPage = 1;
              }
              reqData = {
                customerId: this.selecterVales,
                dateLimit: this.dateLimitPram,
                page: this.userClickPage,
                limit: this.userClickLimit,
                urlId: this.urlId,
                urlName: this.urlName,
                urlType: this.urlType,
                skinId: this.skinId,
                skinName: this.skinName,
                orderByType: this.orderByType
              };
              this.userClickLoading = true;
              _context.p = 1;
              _context.n = 2;
              return (0, _statistic.getUserClickApi)(reqData);
            case 2:
              res = _context.v;
              // console.log(res)
              this.userClickDataList = res.list;
              this.userClickDataTotal = res.total;
              this.userClickLoading = false;
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              this.$message.error(_t.message);
              this.userClickLoading = false;
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function getUserClickData(_x) {
        return _getUserClickData.apply(this, arguments);
      }
      return getUserClickData;
    }(),
    // 处理搜索分析排序
    handleSort2: function handleSort2(field) {
      // 在升序和降序之间切换，不回到空值状态
      if (this.orderByType2 === '' || this.orderByType2 === '2') {
        this.orderByType2 = '1'; // 升序
      } else if (this.orderByType2 === '1') {
        this.orderByType2 = '2'; // 降序
      }

      // 重新获取数据
      this.searchMsgPage = 1; // 重置到第一页
      this.getUserSearchData();
    },
    //获取用户搜索分析数据
    getUserSearchData: function () {
      var _getUserSearchData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var reqData, res, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              this.searchMsgLoading = true;
              reqData = {
                customerId: this.selecterVales,
                dateLimit: this.dateLimitPram,
                page: this.searchMsgPage,
                limit: this.searchMsgLimit,
                orderByType: this.orderByType2
              };
              _context2.p = 1;
              _context2.n = 2;
              return (0, _statistic.searchMsgClickApi)(reqData);
            case 2:
              res = _context2.v;
              this.searchMsgDataList = res.list;
              this.searchMsgDataTotal = res.total;
              this.searchMsgLoading = false;
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              this.$message.error(_t2.message);
              this.searchMsgLoading = false;
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function getUserSearchData() {
        return _getUserSearchData.apply(this, arguments);
      }
      return getUserSearchData;
    }(),
    //分页
    handleSizeChange: function handleSizeChange(limit) {
      this.userClickLimit = limit;
      this.getUserClickData('search');
    },
    pageChange: function pageChange(page) {
      this.userClickPage = page;
      this.getUserClickData('search');
    },
    handleSizeChange2: function handleSizeChange2(limit) {
      this.searchMsgLimit = limit;
      // this.searchMsgPage = 1 // 重置到第一页
      this.getUserSearchData();
    },
    pageChange2: function pageChange2(page) {
      this.searchMsgPage = page;
      this.getUserSearchData();
    },
    checkPermi: _permission.checkPermi,
    handleSeleteRio: function handleSeleteRio(value) {
      this.timeVal = '';
      this.dateLimit = value;
      this.dateLimitPram = value;
      // 重置排序状态和分页状态
      this.orderByType = '';
      this.orderByType2 = '';
      this.searchMsgPage = 1;
      this.userClickPage = 1;
      this.handleDataList();
    },
    // 小程序列表
    handleAppList: function () {
      var _handleAppList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var res;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return (0, _statistic.getBusinessList)();
            case 1:
              res = _context3.v;
              this.selectedList = res.list;
              this.selectedList.unshift({
                customerName: '全部',
                customerId: null
              });
              this.selecterVales = res.list[0].customerId;
              this.$emit('srectEd', this.selecterVales);
              this.handleDataList();
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function handleAppList() {
        return _handleAppList.apply(this, arguments);
      }
      return handleAppList;
    }(),
    handleSeklectEd: function handleSeklectEd(value) {
      this.selecterVales = value;
      this.$emit('srectEd', value);
      // 重置排序状态和分页状态
      this.orderByType = '';
      this.orderByType2 = '';
      this.searchMsgPage = 1;
      this.userClickPage = 1;
      this.handleDataList();
      this.getUserClickData('reset');
      this.getUserSearchData();
    },
    handleDataList: function () {
      var _handleDataList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res, rightDataMap, userEchartData2Y, userEchartData1Y, seriesTwo, series;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return (0, _statistic.getUserData)({
                dateLimit: this.dateLimit,
                customerId: this.selecterVales
              });
            case 1:
              res = _context4.v;
              rightDataMap = {
                '新用户量': res.newUserNum,
                '用户总量': res.totalUserNum,
                '活跃量': res.activeUserNum,
                '流失量': res.lostUserNum,
                '访问量': res.visitNum,
                '人均停留时长': res.averageStayTime,
                '用户已下单量': res.userOrderNum,
                '人均订单金额': res.averageUserOrderAmount
              };
              this.dataRight.forEach(function (item) {
                item.value = rightDataMap[item.name] || 0;
              });
              userEchartData2Y = res.userEchartData2Y;
              userEchartData1Y = res.userEchartData1Y; // 第一个Ecahar
              res.userEchartData1.forEach(function (item) {
                var result = res.userEchartData1Y.reduce(function (acc, key) {
                  acc[key] = 0;
                  return acc;
                }, {});
                Object.keys(item.data || []).forEach(function (key) {
                  if (result.hasOwnProperty(key)) {
                    result[key] = item.data[key];
                  }
                });
                item.data = Object.values(result);
              });
              seriesTwo = res.userEchartData1.map(function (item) {
                return _objectSpread({
                  name: item.customerName,
                  type: 'bar',
                  stack: 'total',
                  label: {
                    show: true
                  },
                  emphasis: {
                    focus: 'series'
                  }
                }, item);
              }); // 第二个Ecahar
              res.userEchartData2.forEach(function (item) {
                var result = res.userEchartData2Y.reduce(function (acc, key) {
                  acc[key] = 0;
                  return acc;
                }, {});
                Object.keys(item.data || []).forEach(function (key) {
                  if (result.hasOwnProperty(key)) {
                    result[key] = item.data[key];
                  }
                });
                item.data = Object.values(result);
              });
              series = res.userEchartData2.map(function (item) {
                return _objectSpread({
                  name: item.customerName,
                  type: 'bar',
                  stack: 'total',
                  label: {
                    show: true
                  },
                  emphasis: {
                    focus: 'series'
                  }
                }, item);
              });
              this.optionData = {
                tooltip: {
                  trigger: 'axis',
                  axisPointer: {
                    type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
                  }
                },
                legend: {},
                grid: {
                  left: '3%',
                  right: '4%',
                  bottom: '3%',
                  containLabel: true
                },
                xAxis: {
                  type: 'value'
                },
                yAxis: {
                  type: 'category',
                  data: userEchartData2Y
                },
                series: series
              };
              this.optionDataTwo = {
                tooltip: {
                  trigger: 'axis',
                  axisPointer: {
                    type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
                  }
                },
                legend: {},
                grid: {
                  left: '3%',
                  right: '4%',
                  bottom: '3%',
                  containLabel: true
                },
                xAxis: {
                  type: 'value'
                },
                yAxis: {
                  type: 'category',
                  data: userEchartData1Y
                },
                series: seriesTwo
              };

              // 同时更新搜索分析数据
              this.getUserClickData('reset');
              this.getUserSearchData();
            case 2:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function handleDataList() {
        return _handleDataList.apply(this, arguments);
      }
      return handleDataList;
    }(),
    // 具体日期
    onchangeTime: function onchangeTime(e) {
      var _this$timeVal;
      this.timeVal = e;
      this.dateLimit = '';
      this.dateLimit = (_this$timeVal = this.timeVal) === null || _this$timeVal === void 0 ? void 0 : _this$timeVal.join(',');
      this.dateLimitPram = this.dateLimit;
      // 重置排序状态和分页状态
      this.orderByType = '';
      this.orderByType2 = '';
      this.searchMsgPage = 1;
      this.userClickPage = 1;
      this.handleDataList();
    },
    exports: function () {
      var _exports = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var th, filekey, data, fileName, lebData;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              th = [], filekey = [], data = [], fileName = '';
              _context5.n = 1;
              return this.getExcelData();
            case 1:
              lebData = _context5.v;
              //表格主要数据
              if (!fileName) fileName = '商品统计表'; //文件名
              if (!filekey.length) {
                filekey = lebData.filekey;
              }
              if (!th.length) th = lebData.header; //表头
              data = data.concat(lebData.exportData);
              (0, _newToExcel.default)(th, filekey, fileName, data);
            case 2:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function exports() {
        return _exports.apply(this, arguments);
      }
      return exports;
    }() // 用于上传导出
    // getExcelData(excelData) {
    //   return new Promise((resolve, reject) => {
    //     productTrendApi({ dateLimit: this.dateLimitPram }).then((res) => {
    //       let header = ['日期/时间', '浏览量', '新增商品数量', '收藏量', '加购件数', '下单商品数', '交易成功商品数']; //表头
    //       let filekey = [
    //         'date',
    //         'pageView',
    //         'addProductNum',
    //         'collectNum',
    //         'addCartNum',
    //         'orderProductNum',
    //         'orderSuccessProductNum',
    //       ]; //表头每一项对应的key
    //       let exportData = new Array();
    //       exportData = res.map((item) => {
    //         return {
    //           date: item.date,
    //           pageView: item.pageView,
    //           addProductNum: item.addProductNum,
    //           collectNum: item.collectNum,
    //           addCartNum: item.addCartNum,
    //           orderProductNum: item.orderProductNum,
    //           orderSuccessProductNum: item.orderSuccessProductNum,
    //         };
    //       });
    //       resolve({ header, filekey, exportData });
    //     });
    //   });
    // },
  }
};